import React from 'react';

export class Endereco extends React.Component {
	constructor() {
		super();
		this.onChange = this.onChange.bind(this);
	}

	onChange(e) {
		const { name, value } = e.target;

		const target = {
			name: 'endereco',
			value: {
				...this.props.value,
				[name]: value,
			},
		};

		this.props.onChange({ target });
	}

	carregaCEP(cep) {
		fetch(`https://viacep.com.br/ws/${cep}/json/`)
			.then(response => response.json())
			.then(dados => {
				const endereco = {
					cep,
					logradouro: dados.logradouro,
					bairro: dados.bairro,
					cidade: dados.localidade,
					uf: dados.uf,
				};

				const target = {
					name: 'endereco',
					value: endereco,
				};

				this.props.onChange({ target });
			});
	}

	render() {
		const { cep, logradouro, bairro, cidade, uf } = this.props.value;

		return (
			<div className="row mb-3">
				<div className="mb-2 col-lg-2 col-sm-3 col-8">
					<label htmlFor="cep">CEP</label>
					<label className="badge badge-pill badge-info">somente números</label>
					<input className="form-control" id="cep" name="cep" type="text" value={cep} onBlur={() => (cep.length === 8) ? this.carregaCEP(cep) : ''} onChange={this.onChange} required placeholder="somente números" minLength="8" maxLength="8" pattern="^[0-9]{8}$" />
				</div>

				<div className="mb-2 col-lg-1 col-sm-2 col-4">
					<label htmlFor="uf">UF</label>
					<input className="form-control" id="uf" name="uf" type="text" value={uf} onChange={this.onChange} required minLength="2" maxLength="2" pattern="^[A-Za-z]{2}$" />
				</div>

				<div className="mb-2 col-lg-6 col-sm-7 col-12">
					<label htmlFor="cidade">Cidade</label>
					<input className="form-control" id="cidade" name="cidade" type="text" value={cidade} onChange={this.onChange} required minLength="2" maxLength="40" pattern={'^.{2,40}$'} />
				</div>

				<div className="mb-2 col-lg-3 col-sm-4 col-12">
					<label htmlFor="bairro">Bairro</label>
					<input className="form-control" id="bairro" name="bairro" type="text" value={bairro} onChange={this.onChange} required minLength="2" maxLength="20" pattern={'^.{2,20}$'} />
				</div>

				<div className="mb-2 col-lg-12 col-sm-8 col-12">
					<label htmlFor="logradouro">Endereço</label>
					<input className="form-control" id="logradouro" name="logradouro" type="text" placeholder="Rua, Avenida, Praça..." value={logradouro} onChange={this.onChange} required minLength="3" maxLength="80" pattern={'^.{3,80}$'} />
				</div>
			</div>
		);
	}
}
